import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { formatINR } from '../utils/formatters';
import { TrendUp, TrendDown, Bank } from '@phosphor-icons/react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function FIIDIIWidget() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await axios.get(`${API}/fii-dii`, { withCredentials: true });
        setData(data);
      } catch {
        setData(null);
      }
    };
    load();
  }, []);

  if (!data) return null;

  return (
    <div className="bg-[#12141A] border border-white/10 p-6" data-testid="fii-dii-widget">
      <div className="flex items-center gap-2 mb-4">
        <Bank size={24} weight="duotone" className="text-[#2563EB]" />
        <h3 className="text-xl font-heading font-bold tracking-tight text-white">FII / DII Activity</h3>
        <span className="text-xs text-[#64748B] ml-auto font-mono">₹ in Crores</span>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="border border-white/10 p-4" data-testid="fii-block">
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#94A3B8] mb-2">
            FII (Foreign)
          </div>
          <div className="flex items-baseline gap-1 mb-2">
            {data.fii.net >= 0 ? (
              <TrendUp size={20} weight="bold" className="text-[#00FF66]" />
            ) : (
              <TrendDown size={20} weight="bold" className="text-[#FF3366]" />
            )}
            <span className={`text-2xl font-mono font-semibold ${data.fii.net >= 0 ? 'text-[#00FF66]' : 'text-[#FF3366]'}`}>
              {data.fii.net >= 0 ? '+' : ''}₹{Math.abs(data.fii.net).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </span>
          </div>
          <div className="text-xs text-[#94A3B8] font-mono space-y-0.5">
            <div>Buy: ₹{data.fii.buy.toLocaleString('en-IN')}</div>
            <div>Sell: ₹{data.fii.sell.toLocaleString('en-IN')}</div>
          </div>
        </div>

        <div className="border border-white/10 p-4" data-testid="dii-block">
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#94A3B8] mb-2">
            DII (Domestic)
          </div>
          <div className="flex items-baseline gap-1 mb-2">
            {data.dii.net >= 0 ? (
              <TrendUp size={20} weight="bold" className="text-[#00FF66]" />
            ) : (
              <TrendDown size={20} weight="bold" className="text-[#FF3366]" />
            )}
            <span className={`text-2xl font-mono font-semibold ${data.dii.net >= 0 ? 'text-[#00FF66]' : 'text-[#FF3366]'}`}>
              {data.dii.net >= 0 ? '+' : ''}₹{Math.abs(data.dii.net).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </span>
          </div>
          <div className="text-xs text-[#94A3B8] font-mono space-y-0.5">
            <div>Buy: ₹{data.dii.buy.toLocaleString('en-IN')}</div>
            <div>Sell: ₹{data.dii.sell.toLocaleString('en-IN')}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
